<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
  mounted() {
    // sessionStorage 临时保存
    // localStorage   长时间保存
    let authority = sessionStorage.getItem('authority')
    if (!authority) {
      sessionStorage.setItem('authority', 'guest')
    }
  },
  methods: {},
}
</script>

<style lang="less">
// img {
//   width: 100%;
//   height: auto;
// }

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;

  // @TODO - org
  overflow-x: hidden;
}
</style>
